module.exports = __webpack_public_path__ + "static/grape-56e5929e5bdca65cd9ae031e93ad246f.svg";